export const GenAIModels = [
    { label: "GPT-4o", value: "GPT-4o" },
    { label: "GROK2", value: "GROK2" },
    { label: "gemini-2.0-flash", value: "gemini-2.0-flash" },
]